import { FC, useEffect, useState } from 'react'
import { PlayIcon, VideoOffIcon } from 'lucide-react'
import { StyledPlayer } from '.'

type Props = {
  svid?: string
  minimal?: boolean
  thumbnail?: string
  loading?: boolean
}

const Player: FC<Props> = ({ svid, loading, thumbnail, minimal }) => {
  const [showSplash, setShowSplash] = useState(true)
  const [playerLoading, setPlayerLoading] = useState(true)
  const [playerError, setPlayerError] = useState(false)
  const [player, setPlayer] = useState<any>()

  const init = () => {
    if (!svid) {
      return player?.pause()
    }

    if (player) {
      return player.setVideo(svid)
    }

    const { SkivPlayer } = window as any

    if (typeof SkivPlayer !== 'function') {
      setPlayerLoading(false)
      setPlayerError(true)
      return
    }

    try {
      const skiv = SkivPlayer({
        container: '#player',
        title: false,
        links: false,
        logo: false,
        resume: true,
        style: minimal ? 'minimal' : undefined,
        width: '100%',
        css: '.player-cover-play, .player-cover-search { display: none !important; }'
      })

      setPlayerLoading(true)
      setPlayer(skiv)

      skiv.on('metadata', () => setPlayerLoading(false))
      skiv.setVideo(svid)
    } catch (error) {
      console.error('SkivPlayer init failed', error)
      setPlayerLoading(false)
      setPlayerError(true)
    }
  }

  const start = () => {
    if (!player) {
      return
    }

    player.play()
    setShowSplash(false)
  }

  useEffect(() => {
    init()
    setShowSplash(true)
  }, [svid])

  return (
    <StyledPlayer $noVid={!svid} $error={playerError} $loading={loading || (playerLoading && !playerError)}>
      {!!svid && showSplash && !playerError && (
        <div onClick={() => start()} className="fake-splash">
          <div className="icon">
            <PlayIcon />
          </div>
        </div>
      )}
      {!svid && thumbnail && <img src={thumbnail} alt="" />}
      {!!svid && playerError && (
        <div className="player-error">
          {thumbnail && <img src={thumbnail} alt="" />}
          <div className="message">
            <VideoOffIcon />
            <span>This video is temporarily unavailable</span>
          </div>
        </div>
      )}
      <div id="player" className="player" />
    </StyledPlayer>
  )
}

export default Player
